/// ContentWrapper
// sets max width
// backStyle - changes background style
// backClass - changes background classname
export default function ContentWrapper(props) {
    let style = { display: "flex", justifyContent: "center" }
    if (props.backStyle) {
        style = { ...style, ...props.backStyle }
    }
    return (
        <div className={props.backClass} style={style}>
            <div style={{ maxWidth: "1264px", width: "100%" }}>
                {props.children}
            </div>
        </div>
    )
}